<template lang="pug">
.form-group
  .input-group
    input.form-control(type='text', v-model="inputText")
    .input-group-append
      button.btn.btn-primary(type='button', @click="copyText") コピー
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: 'デフォルトの値'
    }
  },
  data(){
    return {
      inputText: this.text
    }
  },
  methods: {
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.inputText);
        this.$toasted.success("テキストがクリップボードにコピーされました");
      } catch (err) {
        this.$toasted.error("クリップボードへのコピーに失敗しました");
      }
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
